import React, { useContext } from 'react';
import { useTheme } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { Tooltip } from '@eposnow/ui-core';
import { UserContext } from '../../../context/UserContext';
import useBusinessInformation from '../../../helperHooks/useBusinessInformation';

const DiscountRenderCell = ({
  params,
  checkField,
  numberLimit,
  percentageLimit,
}: {
  params: GridRenderCellParams;
  checkField: string;
  numberLimit?: string;
  percentageLimit?: string;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { locale } = useContext(UserContext);
  const { currencyISOCode } = useBusinessInformation();

  if (!params.row?.[checkField]) {
    return (
      <CloseIcon
        key={`${checkField}-discount-disabled-${params?.row?.id}`}
        sx={{ color: 'icon.default' }}
      />
    );
  }

  const limits = [];
  if (numberLimit && typeof params.row?.[numberLimit] === 'number') {
    limits.push(
      currencyISOCode
        ? Intl.NumberFormat(locale, {
            currency: currencyISOCode,
            style: 'currency',
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(params.row?.[numberLimit])
        : `${params.row?.[numberLimit]}`
    );
  }

  if (percentageLimit && typeof params.row?.[percentageLimit] === 'number') {
    limits.push(`${params.row?.[percentageLimit]}%`);
  }

  let tooltip: string;
  switch (limits.length) {
    case 1:
      tooltip = t('screens.staffRoles.maxLimit', { param0: limits[0] });
      break;
    case 2:
      tooltip = t('screens.staffRoles.maxLimit2', {
        param0: limits[0],
        param1: limits[1],
      });
      break;
    default:
      tooltip = t('screens.staffRoles.noLimit');
      break;
  }

  return (
    <Tooltip
      key={`${checkField}-discount-enabled-${params?.row?.id}`}
      title={tooltip}
      theme={theme}
    >
      <CheckIcon
        key={`${checkField}-discount-enabled-${params?.row?.id}`}
        sx={{ color: 'success.main' }}
      />
    </Tooltip>
  );
};

export default DiscountRenderCell;
